import axios from 'axios';

export async function loadMultiRecommendations() {
  const apiUrl = window.location.origin;
  const response = await axios.get(`${apiUrl}/.rest/delivery/multi-recommendations`);
  const results = response.data.results || [];
  if (!results.length) return [];

  const surveyData = results.find(item => item['@name'] === 'survey-data');
  if (!surveyData || !Array.isArray(surveyData['@nodes'])) return [];

  return surveyData['@nodes']
    .map(key => surveyData[key])
    .filter(child => child && child['@nodeType'] === 'lib:multi-recommendations')
    .map(child => ({
      name: child.name,
      tags: child.tags,
      description: child.description,
      recommendation: child.recommendation,
      recommendationSection: child.recommendationSection,
      type: child.type || 'and',
      minimum: child.minimum || undefined,
      hideSingle: child.hideSingle || false,
      image: child.image,
      imageCaption: child.imageCaption,
      showOnRight: child.showOnRight || false
    }));
}

export async function loadReferences() {
  const apiUrl = window.location.origin;
  const response = await axios.get(`${apiUrl}/.rest/delivery/references`);
  const results = response.data.results || [];
  if (!results.length) return [];

  const surveyData = results.find(item => item['@name'] === 'survey-data');
  if (!surveyData || !Array.isArray(surveyData['@nodes'])) return [];

  return surveyData['@nodes']
    .map(key => surveyData[key])
    .filter(child => child && child['@nodeType'] === 'lib:references')
    .map(child => ({
      name: child.name,
      reference: child.reference,
      tags: child.tags
    }));
}

export async function loadQuestionsFromDelivery() {
  const apiUrl = window.location.origin;
  const response = await axios.get(`${apiUrl}/.rest/delivery/questions`);

  let allAnswers = [];
  let questionRecommendations = {};

  response.data.results.forEach(folder => {
    if (folder && Array.isArray(folder['@nodes'])) {
      folder['@nodes'].forEach(nodeKey => {
        const node = folder[nodeKey];
        if (node && node['type'] === 'question') {
          if (node.recommendation || node.recommendationSection) {
            questionRecommendations[node.name] = {
              recommendation: node.recommendation,
              recommendationSection: node.recommendationSection
            };
          }
        } else if (node && node['type'] === 'answer') {
          allAnswers.push({ 
            key: node.name, 
            recommendation: node.recommendation, 
            recommendationSection: node.recommendationSection,
            references: node.references,
            image: node.image,
            imageCaption: node.imageCaption,
            showOnRight: node.showOnRight || false
          });
        }
      });
    }
  });

  return { allAnswers, questionRecommendations };
}